import { render, staticRenderFns } from "./milestone-tab.vue?vue&type=template&id=12568f7c&"
import script from "./milestone-tab.vue?vue&type=script&lang=js&"
export * from "./milestone-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports